import { Component } from "react";
import { AlertTriangle, RefreshCcw, Home } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[AZD ErrorBoundary]", error, info?.componentStack);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.message || "Bilinmeyen bir hata oluştu.";
    return (
      <div
        data-testid="error-boundary"
        className="min-h-[60vh] flex items-center justify-center p-6"
      >
        <div className="azd-card p-8 max-w-lg text-center">
          <div className="w-14 h-14 mx-auto rounded-full bg-[#FEF2F2] text-[#DC2626] flex items-center justify-center mb-4">
            <AlertTriangle size={28} />
          </div>
          <h2 className="text-lg font-extrabold text-[#08285A] mb-2">
            Bir şeyler ters gitti
          </h2>
          <p className="text-sm text-[#6B7280] mb-1">
            Bu sayfa yüklenirken beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.
          </p>
          <p className="text-xs text-[#DC2626] font-mono bg-[#FEF2F2] rounded px-3 py-2 my-4 text-left break-all">
            {msg}
          </p>
          <div className="flex gap-2 justify-center">
            <button
              onClick={this.reset}
              data-testid="error-boundary-retry"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-[#0B3676] hover:bg-[#08285A] text-white text-sm font-semibold"
            >
              <RefreshCcw size={14} /> Tekrar Dene
            </button>
            <a
              href="/"
              data-testid="error-boundary-home"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg border border-[#E5E7EB] text-[#111827] text-sm font-semibold hover:bg-[#F6F8FB]"
            >
              <Home size={14} /> Ana Sayfa
            </a>
          </div>
        </div>
      </div>
    );
  }
}
